module.exports = __webpack_public_path__ + "static/media/Joy-sm.790869e2.jpg";